module.exports = __webpack_public_path__ + "static/media/city-elements-facilities-10-svgrepo-com.f6313582.svg";